var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchreLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "208px",
    height: "53px",
    viewBox: "0 0 208 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.06 0.848 27.522 0.848 27.522 25.94 0.06 25.94"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Program-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD_1440p_program_draft-program_delete1",
    transform: "translate(-32.000000, -35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top-nav"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arch-RE-Logo-PMS-2018",
    transform: "translate(32.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-1",
    fill: "#0065A3",
    mask: "url(#mask-2)",
    points: "21.692 5.512 0 11.795 8.276 0.848 8.146 5.918 21.692 5.512"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-3",
    fill: "#0065A3",
    mask: "url(#mask-2)",
    points: "27.522 5.194 18.752 26 15.451 12.68 19.31 15.978 27.522 5.194"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-5",
    fill: "#0065A3",
    points: "29.879 27.871 40.433 47.828 28.035 41.953 33.026 41.051 29.879 27.871"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-6",
    fill: "#0065A3",
    points: "28.189 22.187 50.422 26.106 38.17 32.296 40.523 27.795 28.189 22.187"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-7",
    fill: "#0065A3",
    points: "24.151 20.771 41.434 6.227 38.305 19.591 36.371 14.905 24.151 20.771"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-8",
    fill: "#0065A3",
    points: "19.542 23.357 18.568 0.797 27.249 11.423 22.352 10.101 19.542 23.357"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-9",
    fill: "#0065A3",
    points: "19.017 28.63 0.611 15.55 14.334 15.226 10.281 18.272 19.017 28.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.064,12.453 L66.962,12.453 L62.83,25.006 L71.146,25.006 L67.064,12.453 Z M71.817,26.813 L62.262,26.813 L60.247,32.752 C59.265,35.644 58.75,37.866 61.849,37.917 L61.849,38.795 L54.205,38.795 L54.205,37.917 C56.993,37.504 57.665,36.005 58.593,33.268 L66.755,8.89 L69.803,8.89 L78.377,34.354 C79.256,37.09 79.978,37.917 82.611,37.917 L82.611,38.795 L72.179,38.795 L72.179,37.917 C74.194,37.917 75.174,37.039 74.504,35.024 L71.817,26.813 L71.817,26.813 Z",
    id: "Fill-10",
    fill: "#0065A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.128,35.335 C91.128,37.349 91.749,37.917 94.175,37.917 L94.175,38.795 L84.516,38.795 L84.516,37.917 C87.306,37.917 87.617,37.195 87.617,34.405 L87.617,24.438 C87.617,21.75 86.945,21.44 83.846,21.44 L83.846,20.563 L90.251,19.995 L91.128,19.995 L91.128,23.973 C94.537,21.027 96.138,19.995 97.379,19.995 C98.411,19.995 99.805,20.615 100.735,21.44 L99.341,24.695 C97.843,23.869 96.242,23.094 95.002,23.094 C93.815,23.094 92.781,23.714 91.128,25.314 L91.128,35.335",
    id: "Fill-11",
    fill: "#0065A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.726,26.451 L116.847,26.451 C116.071,23.146 113.749,21.027 110.699,21.027 C107.083,21.027 104.554,24.128 104.554,28.619 C104.554,33.63 107.705,37.814 111.424,37.814 C113.645,37.814 116.331,36.625 118.241,33.993 L118.241,35.335 C116.278,38.019 113.49,39.363 110.184,39.363 C104.761,39.363 100.99,35.592 100.99,30.119 C100.99,24.489 105.226,19.995 110.442,19.995 C113.18,19.995 114.678,21.027 115.607,21.027 C116.071,21.027 116.537,20.668 116.847,19.995 L117.726,19.995 L117.726,26.451",
    id: "Fill-12",
    fill: "#0065A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.691,34.405 C138.691,37.195 139.206,37.917 141.635,37.917 L141.635,38.795 L132.131,38.795 L132.131,37.917 C134.61,37.917 135.177,37.349 135.177,34.974 L135.177,25.935 C135.177,23.507 133.732,21.956 131.511,21.956 C129.445,21.956 127.947,22.938 126.19,25.419 L126.19,35.438 C126.19,37.349 126.965,37.917 129.239,37.917 L129.239,38.795 L119.424,38.795 L119.424,37.917 C122.163,37.866 122.679,37.349 122.679,34.405 L122.679,10.594 C122.679,8.218 122.007,7.857 119.424,7.857 L119.424,6.98 L125.313,6.358 L126.19,6.358 L126.19,23.662 C128.514,20.975 130.22,19.995 132.595,19.995 C135.643,19.995 138.691,22.007 138.691,26.349 L138.691,34.405",
    id: "Fill-13",
    fill: "#0065A3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#1E272E",
    points: "155.204 52.505 156.325 52.505 156.325 0.749 155.204 0.749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.714,26.269 L178.748,26.269 C182.952,26.269 184.599,23.407 184.599,20.547 C184.599,17.254 182.129,14.913 178.314,14.913 L175.714,14.913 L175.714,26.269 Z M175.714,34.114 C175.714,37.148 176.494,38.058 178.531,38.058 L178.531,38.795 L169.602,38.795 L169.602,38.058 C171.509,38.058 172.419,37.451 172.419,34.114 L172.419,18.554 C172.419,15.303 171.596,14.696 169.602,14.696 L169.602,13.959 L179.788,13.959 C185.38,13.959 188.067,17.166 188.067,20.461 C188.067,23.191 186.593,25.488 182.952,26.573 C187.59,29.563 189.151,37.755 193.269,38.058 L193.269,38.795 L188.197,38.795 C183.559,33.161 182.258,27.309 177.708,27.309 L175.714,27.309 L175.714,34.114 L175.714,34.114 Z",
    id: "Fill-15",
    fill: "#1E272E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.731,28.696 C204.861,25.315 202.564,23.928 200.613,23.928 C198.056,23.928 196.539,25.836 196.365,28.696 L204.731,28.696 Z M196.365,29.433 C196.279,36.325 200.396,38.058 202.477,38.058 C204.601,38.058 205.685,37.322 207.896,34.851 L207.896,35.978 C206.031,38.362 204.254,39.273 201.567,39.273 C196.756,39.273 193.288,35.935 193.288,31.296 C193.288,26.659 196.669,23.018 201.003,23.018 C204.558,23.018 207.852,25.878 207.635,29.433 L196.365,29.433 L196.365,29.433 Z",
    id: "Fill-16",
    fill: "#1E272E"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchreLogoBlue);
export default __webpack_public_path__ + "static/media/archre-logo-blue.90dc991e94db4ed24af362b63caf9ad2.svg";
export { ForwardRef as ReactComponent };